import React, { Component } from 'react';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';

// import Icon from '@vzrf/react-icon';
// import { FormGroup, Input } from '@vzrf/react-forms';
import SearchIcon from "@vds/icons/search";
import AlternateCheckmark from "@vds/icons/alternate-checkmark";
import { breakpoints } from '@vzrf/react-theme-helpers';
import AutoComplete from 'react-autocomplete';

//import { ChannelsData } from '../../assets/data/channels';
import ResultsFilter from '../FilterTabs';
import { updateSCTags } from '../../../../service/dtmTag';


const ChannelListFilterTabContainer = styled.div`
    border-bottom: 1px solid #767676;
    margin: ${calculateRem(0, 0, 26, 0)};

    @media only screen and (min-width: ${breakpoints.md}) {
        margin:  ${calculateRem(10, 20, 20, 20)};
    };

    @media only screen and (max-width:767px) {
        margin-bottom:1em;
    };
`;

const ChannelListFilterContentContainer = styled.div`
    height: ${calculateRem(230)};
    overflow-y: auto; 
    margin:  ${calculateRem(0, 10)};
    @media only screen and (min-width: ${breakpoints.md}) {
        margin:  ${calculateRem(5, 20, 20, 20)};
        height: calc(90vh - 342px);
        max-height: 250px;
    };

    @media only screen and (max-width: 767px) {

        height: calc(100vh - 450px);
        max-height: ${calculateRem(230)};
        min-height: ${calculateRem(100)};
    };

    @media only screen and (max-width: 350px) {
        height: calc(30vh);
        max-height: ${calculateRem(230)};
        min-height: ${calculateRem(100)};
    };
`;

const ChannelListSearchContainer = styled.div`
    max-width: ${calculateRem(630)};
    margin: 0 auto;    
`;

const ChannelListContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: relative;
    left: ${calculateRem(-5)};
    max-width: ${calculateRem(630)};    
    margin: 0 auto;   
    padding:4px;
`;

const ChannelListContainerRskn = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: relative;
    left: ${calculateRem(-5)};
    max-width: ${calculateRem(630)};    
    margin: 0 auto;   
    padding:4px;
`;

const ChannelListItem = styled.div`
    position: relative;
    width: ${calculateRem(85)};
    height: ${calculateRem(63)};
    margin: ${calculateRem(5)};
    background: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    & .disable-img {
        opacity: 0.5;
        cursor: not-allowed;
      }
`;

const ChannelListItemRskn = styled.div`
    position: relative;
    width: ${calculateRem(125)};
    height: ${calculateRem(93)};
    margin: ${calculateRem(6)};
    // background: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #6F7171;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    & .disable-img {
        opacity: 0.5;
        cursor: not-allowed;
      }
    @media only screen and (max-width:767px) {
        width: 93px;
    };
`;

const SelectedChannelCheck = styled.div`
        height: ${calculateRem(10)};
        width: ${calculateRem(10)};
        display: flex;
        border-radius: ${calculateRem(10)};
        overflow: hidden;
        position: absolute;
        right:  ${calculateRem(5)};
        top: ${calculateRem(5)};
        & svg {
            margin:  ${calculateRem(-1)};
        }
`;

// Not being used, hence commenting
// const SearchInput = styled.div`
//         & ${Input} {
//             width: 100%;
//         }
// `;

const SearchInstruction = styled.p`
    font-weight: bold;
    color: #0f0f0f;
    margin:  ${calculateRem(20, 0)};
    line-height: 1.25;
    letter-spacing: 0.25px;

    @media only screen and (min-width: ${breakpoints.md}) {
        margin:  ${calculateRem(33, 0, 20)};
    };
`;

const SimilarMatchInfo = styled.p`
    color: #0f0f0f;
    margin:  ${calculateRem(20, 0)};

    @media only screen and (min-width: ${breakpoints.md}) {
        margin:  ${calculateRem(33, 0)};
    };
`;

const SimilarMatchText = styled.span`
    color: #398dfa;
    cursor: pointer;
`;

let filters = [];

const filterStyles = {
    height: '62px',
    border: 'none',
};

const setSelectedTab = (filterId) => {
    for (let i = 0; i < filters.length; i++) {
        if(filters[i].id === filterId) {
            filters[i].isSelected = 'true'
        } else {
            filters[i].isSelected = 'false'
        }
    }
    return filters;
}

let ChannelsData = [];
let domain=window.location.origin;

// data from mock
const filterChannelData = (filterId, filterText, localChannelsAndMajorNetworks, premiumChannels) => {
    let data = {
        channelList: [],
        similarMatch: '',
        hasLChannelsAndMNetworks: false,
        hasPremiumChannels: false
    }

    const addedlChannelsAndMNetworksList = [];
    const searchingPremiumChannels = [];
    
    if(filterId !== 'search') {
        if(filterId === 'all'){
            data.channelList=[...ChannelsData]
        }else{
            for(let i=0; i < ChannelsData.length; i++) {
            
                if(ChannelsData[i].channelCategory.indexOf(filterId) !== -1) {
                    data.channelList.push(ChannelsData[i]);
                }
            }
        }

        
    } else if(filterId === 'search' && filterText) {
        if(filterText.length >= 3) {
            for(let i=0; i < ChannelsData.length; i++) {
                
                const category = ChannelsData[i].channelCategory && ChannelsData[i].channelCategory.join().toUpperCase();
                const name = ChannelsData[i].name.toUpperCase();
                const text = filterText.toUpperCase();
                
                const lcAndmn = localChannelsAndMajorNetworks ? localChannelsAndMajorNetworks.join().toUpperCase() : [];
                const premiumChs = premiumChannels ? premiumChannels.join().toUpperCase() : [];         

                if(category.indexOf(text) !== -1 || name.indexOf(text) !== -1) {
                    data.channelList.push(ChannelsData[i]);
 
                    if(lcAndmn.indexOf(name) > -1) {
                        addedlChannelsAndMNetworksList.push(name);
                    }                 
                }

                if(premiumChs.indexOf(text) > -1) {
                    searchingPremiumChannels.push(name);
                } 
            }
        }

        if(filterText === 'natonal geoga') {
            const similarText = 'National Geographic';    
            data = filterChannelData('search', similarText);
            data.similarMatch = similarText;
        } else {
            data.similarMatch = ''
        }

        addedlChannelsAndMNetworksList.length > 0 ? data.hasLChannelsAndMNetworks = true : data.hasLChannelsAndMNetworks = false;
        searchingPremiumChannels.length > 0 ? data.hasPremiumChannels = true : data.hasPremiumChannels = false;
      
    }

    //sort channels
    data.channelList.length && data.channelList.sort(sortChannels);

    return data;
}

const sortChannels = (channelA, channelB) => {
    if (channelA.name.toLowerCase() < channelB.name.toLowerCase()) {
        return -1;
    } else if (channelA.name.toLowerCase() > channelB.name.toLowerCase()) {
        return 1;
    } else {
        return 0;
    }
};

class ChannelListComponent extends Component {

    constructor(props) {
        super(props);
        const defaultTab = 'popular';
        setSelectedTab(defaultTab);
        const localChannelsAndMajorNetworks = ['ABC', 'CBS', 'NBC', 'FOX'];
        const premiumChannels = ['HBO', 'STARZ', 'Cinemax', 'Showtime', 'MGM+'];
        
        //const channelData = filterChannelData(defaultTab);

        this.state = {
            filterTabs: filters,
            //channelList: channelData.channelList,
            channelList: [],
            similarMatch: '',
            searchValue: '',
            selectedFilterTabId: defaultTab,
            selectedChannels: props.setSelectedChannels,
            localChannelsAndMajorNetworks: localChannelsAndMajorNetworks,
            //hasLChannelsAndMNetworks: channelData.hasLChannelsAndMNetworks,
            hasLChannelsAndMNetworks: undefined,
            premiumChannels: premiumChannels,
            //hasPremiumChannels: channelData.hasPremiumChannels
            hasPremiumChannels: undefined,
            showOtherPackagesMessage: false
        };   
        
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }

    componentDidMount() {
        ChannelsData = this.props.channelsData;
        if (!filters.length) {
            filters = this.getChannelsCategories();
        }
        let defaultTab = 'popular';
        if(filters.length) {
            const index = filters.findIndex(val => val.id === 'popular');
            if(index === -1) {
                defaultTab = (filters[0].id === "search" && filters.length > 1) ? filters[1].id: filters[0].id;
            }
        }
        const channelData = filterChannelData(defaultTab);
        filters = setSelectedTab(defaultTab);
        this.setState({
            filterTabs: filters,
            channelList: channelData.channelList,
            hasLChannelsAndMNetworks: channelData.hasLChannelsAndMNetworks,
            hasPremiumChannels: channelData.hasPremiumChannel
        });        
    }

    addNavEventListner = () => {
            const autoCompleteSearch = document.querySelector('.channel-list-auto-search');
            if(autoCompleteSearch) {
                autoCompleteSearch.addEventListener('keydown', this.handleUpAndDownNavEvent);
                console.log('autoCompleteSearch', autoCompleteSearch);             
            }
    }
    handleUpAndDownNavEvent = (event) => {
        if (event.keyCode && (event.keyCode === 40 || event.keyCode === 38)) {
            setTimeout(() => {
                const selectedOption = document.querySelector('#selectedOption');
                if (selectedOption) {
                    const autoCompleteSearch = document.querySelector('.channel-list-auto-search');
                    console.log('selectedOption', selectedOption);
                    const value = selectedOption.getAttribute('data-item-value');
                    if (value) {
                        autoCompleteSearch.value = value;
                    }
                }
            });
        }
        if (event.keyCode && event.keyCode === 9 && !event.shiftKey) {
            let highlightedItem = document.getElementById("selectedOption")
            if (highlightedItem) {
                this.onSearchResultSelect(event, JSON.parse(highlightedItem.getAttribute("item")));
                event.preventDefault();
            }
            else {
                let parent = document.querySelector(".sc-dnqmqq")
                let nextsibling = parent.firstElementChild && parent.firstElementChild.firstElementChild
                if (nextsibling) {
                    this.handleSelectedChannelTab(nextsibling.getAttribute("id"))
                    nextsibling.getElementsByTagName("button")[0].focus()
                }
                // event.preventDefault();
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.showOtherPackagesMessage && this.state.selectedChannels.length < 5) {
            this.setState({showOtherPackagesMessage: false});
        }
        const modalFiosFiveEle = document.querySelector('#FIOSFIVE');
        const channelWrapperEle = modalFiosFiveEle.querySelector('.sc-chPdSV');
        if (prevProps.matchedChannelList !== this.props.matchedChannelList && this.state.selectedFilterTabId === 'search' && channelWrapperEle && channelWrapperEle.firstElementChild) {
            channelWrapperEle.lastElementChild.onkeydown = (e) => {
                if (e.keyCode && e.keyCode === 9 && !e.shiftKey) {
                    this.focusFirstChannelTab()
                }
            }
            channelWrapperEle.firstElementChild.focus();
        }
        if (prevProps.matchedChannelList !== this.props.matchedChannelList && this.state.selectedFilterTabId === 'search' && channelWrapperEle && !channelWrapperEle.childNodes.length) {
            const closeBtn = document.querySelector('.styles_closeButton__20ID4');
            const channelListBtn = document.querySelector("#complete-channel-listing")
            let parent = document.querySelector(".sc-dnqmqq")
            let nextsibling = parent.firstElementChild && parent.firstElementChild.firstElementChild
            if (channelListBtn && this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5) {
                channelListBtn.focus()
            }
            else if (nextsibling) {
                this.handleSelectedChannelTab(nextsibling.getAttribute("id"))
                nextsibling.getElementsByTagName("button")[0].focus()
            } else if (closeBtn) {
                closeBtn.focus()
            }
        }
        const channelContainer = document.querySelector("#channelContainer")
        if (channelContainer && channelContainer.firstElementChild && channelContainer.firstElementChild.lastElementChild) {
            const lastChannelItem = channelContainer.firstElementChild.lastElementChild
            lastChannelItem.onkeypress = (e) => this.tabOnLastChannelItem(e, this.handleSelectedChannelTab)
        }
    }

    tabOnLastChannelItem = function (event, handleSelectedChannelTab) {
        if (event.keyCode === 9 && !event.shiftKey && event.target.getAttribute("id") !== "search") {
            let parent = document.querySelector(".sc-dnqmqq")
            let currentEl = parent.firstElementChild && parent.firstElementChild.querySelectorAll(".sc-iwsKbI.active")[0]
            let nextsibling = currentEl && currentEl.nextElementSibling
            if (nextsibling) {
                handleSelectedChannelTab(nextsibling.getAttribute("id"))
                nextsibling.getElementsByTagName("button")[0].focus()
            } else {
                const closeBtn = document.querySelector('.styles_closeButton__20ID4');
                closeBtn.focus();
            }
        }
        else if (event.target.getAttribute("id") === "search") {
            const autoCompleteSearch = document.querySelector('.channel-list-auto-search');
            if (autoCompleteSearch) {
                this.handleUpAndDownNavEvent(event)
            }
        }
    }

    getChannelsCategories = () => {
        let categories = [];
        ChannelsData.forEach(val => {
            categories = categories.concat(val.channelCategory);
        });
        let uniqueCategories = categories.reduce((a, b) => {
            if (a.indexOf(b) < 0) a.push(b);
            return a;
        }, []).filter(item => item);
        //sort ascending
        uniqueCategories.sort();
        uniqueCategories = uniqueCategories.map((val) => {
            return {
                id: val,
                title: val ? val : '',
                isSelected: "false"
            }
        });
        const index = uniqueCategories.findIndex(val => {
            return val.id && val.id.toLocaleLowerCase() === 'popular';
        });
        if (index !== -1) {
            const temp = uniqueCategories[index];
            uniqueCategories.splice(index, 1);
            uniqueCategories.unshift(temp);
        }
        uniqueCategories.push({ id: 'all', title: "All"});
        uniqueCategories.unshift({ id: 'search', title: <SearchIcon size="20" />, isSelected: "false" });
        return uniqueCategories;
    }

    selectSearchTab = (e) => {
        if (e.keyCode === 39 && e.target.getAttribute("data-testid")) {
            this.handleSelectedChannelTab("search")
            document.querySelector("#search").getElementsByTagName("button")[0].focus()
            e.preventDefault()
        }
        if (e.keyCode === 36 && e.target.getAttribute("data-testid")) {
            this.handleSelectedChannelTab("search")
            document.querySelector("#search").getElementsByTagName("button")[0].focus()
            e.preventDefault()
        }
        if ((e.keyCode === 35 || e.keyCode === 37) && e.target.getAttribute("data-testid")) {
            this.focusLastChannelTab();
            e.preventDefault();
        }
    }

    handleChipClick = (filterId, event) => {
        this.handleSelectedChannelTab(filterId)
        if (filterId === 'search') {
            this.addNavEventListner()
        }
        if (event.keyCode && (event.keyCode === 13 || event.keyCode === 32)) {
            this.handleSelectedChannelTab(filterId)
            setTimeout(() => {
                const modalFiosFiveEle = document.querySelector('#FIOSFIVE');
                if (filterId === 'search') {
                    const searchInputEle = modalFiosFiveEle.querySelector('.searchInput');
                    searchInputEle && searchInputEle.focus();
                } else {
                    const channelWrapperEle = modalFiosFiveEle.querySelector('.sc-chPdSV');
                    if (channelWrapperEle && channelWrapperEle.firstElementChild) {
                        channelWrapperEle.firstElementChild.focus();
                    }
                }
            }, 300);
        }
        if (event.keyCode === 39 || event.keyCode === 37) {
            if (filterId !== 'search') {
                // console.log("Filter id" + filterId)
                let parent = event.target.parentNode;
                // console.log("Parent" + parent);
                if (event.keyCode === 39) {
                    let nextsibling = parent.nextElementSibling;
                    // console.log("Next sibling" + nextsibling);
                    if (nextsibling) {
                        this.handleSelectedChannelTab(nextsibling.getAttribute("id"))
                        nextsibling.getElementsByTagName("button")[0].focus()
                    } else {
                        this.handleSelectedChannelTab("search")
                        document.querySelector("#search").getElementsByTagName("button")[0].focus()
                    }
                }
                else if (event.keyCode === 37) {
                    let prevsibling = parent.previousElementSibling;
                    // console.log("Prev sibling" + prevsibling);
                    if (prevsibling) {
                        this.handleSelectedChannelTab(prevsibling.getAttribute("id"))
                        prevsibling.getElementsByTagName("button")[0].focus()
                    } else {
                        this.handleSelectedChannelTab("search")
                        document.querySelector("#search").getElementsByTagName("button")[0].focus()
                    }
                }
            }
            else {
                if (event.keyCode === 39) {
                    this.focusFirstChannelTab();
                }
                if (event.keyCode === 37) {
                    this.focusLastChannelTab();
                }
            }
        }
        if (event.keyCode === 36) {
            this.handleSelectedChannelTab("search");
            document.querySelector("#search").getElementsByTagName("button")[0].focus();
        }
        if (event.keyCode === 35) {
            this.focusLastChannelTab();
        }

        if (event.keyCode === 39) {
            if (filterId === 'search') {
                let parent = document.getElementById('search').parentNode;
                // console.log("parent  ----> " + parent);
                let nextsibling = parent.nextElementSibling;
                // console.log("XX -nextsibling  ----> " + nextsibling);

                if (nextsibling) {
                    // this.handleSelectedChannelTab(nextsibling.getAttribute("id"))
                    // nextsibling.getElementsByTagName("button")[0].focus();
                    
                    this.handleSelectedChannelTab("popular");
                    document.querySelector("#popular").getElementsByTagName("button")[0].focus();
                } 
                // else {
                //     this.handleSelectedChannelTab("search")
                //     document.querySelector("#search").getElementsByTagName("button")[0].focus()
                // }      
            }
        }
    };
    
    focusFirstChannelTab = () => {
        let parent = document.querySelector(".sc-dnqmqq")
        let nextsibling = parent.firstElementChild && parent.firstElementChild.firstElementChild
        nextsibling && this.handleSelectedChannelTab(nextsibling.getAttribute("id"))
        nextsibling && nextsibling.getElementsByTagName("button")[0].focus()
    }

    focusLastChannelTab = () => {
        let parent = document.querySelector(".sc-dnqmqq")
        let lastsibling = parent.firstElementChild && parent.firstElementChild.lastElementChild
        lastsibling && this.handleSelectedChannelTab(lastsibling.getAttribute("id"))
        lastsibling && lastsibling.getElementsByTagName("button")[0].focus()
    }
    
    findFilterChip = (filterTabs,filterId)=>{
         return filterTabs.filter(filter=>filter.id === filterId)[0]
    }

    handleSelectedChannelTab = (filterId) => {
        const filterTabs = setSelectedTab(filterId);
        updateSCTags(filterId + " Selected");
        const channelData = filterChannelData(filterId);
        this.setState({
            filterTabs: filterTabs,
            selectedFilterTabId: filterId,
            channelList: channelData.channelList
        });
    }

    addToSelectedChannel = (channel) => {        
        const selestedChannels = this.state.selectedChannels;
        if (this.state.selectedChannels.length < 5 ) {
            if(this.isSelectedChannel(channel.id) === false) {
                selestedChannels.push(channel);
                channel.name = channel.name.replace(/[^\w\s]/gi, '');
                updateSCTags("yftv add- " + channel.name);
            }
        } else {
            this.state.selectedFilterTabId === 'search' &&
            this.setState({
                showOtherPackagesMessage: true
            });
        }

        this.setState({
            selectedChannels: selestedChannels
        });
        this.props.selectedChannels(this.state.selectedChannels);
    }

    isSelectedChannel(channelId) {
        let isSeleted = false;
        if(this.state.selectedChannels.map(function(e) { return e.id; }).indexOf(channelId) !== -1) {
            isSeleted = true;
        }
        return isSeleted;
    }

    getImgPath(logoImg) {
        return this.props.channelImgPath + logoImg;
    }

    handleKeyDown = (e,channel) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.addToSelectedChannel(channel);
        }
    }

    doSearch(filterId, filterText) {
        // const filterText = filterEvent.target.value;
        const data = filterChannelData(filterId, filterText, this.state.localChannelsAndMajorNetworks, this.state.premiumChannels);
        console.log(data.similarMatch);
        this.setState({
            selectedFilterTabId: filterId,
            channelList: data.channelList,
            similarMatch: data.similarMatch,
            searchValue: filterText,
            hasLChannelsAndMNetworks: data.hasLChannelsAndMNetworks,
            hasPremiumChannels: data.hasPremiumChannels
        });

        this.setState({showOtherPackagesMessage: false});
    }

    doApiSearch = (filterText) => {
        this.setState({
            searchValue: filterText
        });

        if (!filterText) {
            this.setState({
                hasLChannelsAndMNetworks: false,
                hasPremiumChannels: false
            });
            //begin API search updates
            filterText.length && this.props.onSearchInput(filterText);
        } else {
            if (this.isLocalChannelSearch(filterText)) {
                this.setState({
                    hasLChannelsAndMNetworks: true,
                    hasPremiumChannels: false
                })
            } else if (this.isPremiumChannelSearch(filterText)) {
                this.setState({                    
                    hasPremiumChannels: true,
                    hasLChannelsAndMNetworks: false
                })
            } else {
                this.setState({
                    hasLChannelsAndMNetworks: false,
                    hasPremiumChannels: false
                });                
                //begin API search updates
                this.props.onSearchInput(filterText);
            }
        }
    };

    isLocalChannelSearch = (searchString) => {
        if (searchString && this.state.localChannelsAndMajorNetworks.indexOf(searchString.toUpperCase()) !== -1) {
            console.log("LOCAL CHANNEL SEARCH ", searchString);
            return true;
        } else {
            return false;
        }
    };

    isPremiumChannelSearch = (searchString) => {
        if (searchString) {
            searchString = searchString.toUpperCase();
            return this.state.premiumChannels.some((el) => searchString === el.toUpperCase());
        } else {
            return false;
        }
    };

    onSearchResultSelect = (e, item) => {
        console.log(e, item);
        console.log(item)
        this.setState({searchValue:item.name||item.Title})
        this.props.onSearchInput(this.state.searchValue, item);
        updateSCTags("search- " + item.name);
    }

    accesibilityChannelNameHandler = (name) => {
        if(name.includes("Channel")){
            return name
        }else{
            return name + " Channel"
        }
    }
   
    render() {

        return (            
            <React.Fragment>
            <ChannelListFilterTabContainer>
            
                <ResultsFilter
                filters={this.state.filterTabs}
                    handleChipClick={this.handleChipClick}
                    filterStyles={filterStyles}
                    selectSearchTab={this.selectSearchTab}
                    />

            </ChannelListFilterTabContainer>
            <ChannelListFilterContentContainer role='tabpanel' id="channelContainer" aria-labelledby='chanelCategoryItem'>
            
                {this.state.selectedFilterTabId === 'search' && 
                <ChannelListSearchContainer role="null">
                        {/* Commenting Form group as only Auto complete is used inside it.
                         <FormGroup> */}
                            {/* <input placeholder="Search shows and channels" value={this.state.searchValue}   onChange={(event) => this.doSearch('search', event.target.value)} /> */}
                            <AutoComplete
                                getItemValue={item => item.name || item.Title}
                                items={this.props.searchSuggestions || []}
                                onChange={(event) => this.doApiSearch(event.target.value)}
                                onSelect={this.onSearchResultSelect}
                                // selectOnBlur={true}
                                wrapperStyle={{
                                    display: 'block',
                                    position: 'relative',
                                    zIndex: '1000'
                                }}
                                menuStyle={{
                                    borderRadius: '3px',
                                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    padding: '2px 0',
                                    fontSize: '90%',
                                    position: 'fixed',
                                    overflow: 'auto',
                                    maxHeight: '35%', 
                                }}
/*                              wrapperProps={{style: {
                                    height: "20%",
                                    width: "70%",
                                    margin: "5px 0px",
                                    background: "tomato"
                                }}} */
                                renderMenu= {(items,value,style)=>{
                                    const menuStyle={
                                        borderRadius: '3px',
                                        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        padding: '2px 0',
                                        fontSize: '90%',
                                        position: 'fixed',
                                        overflow: 'auto',
                                        maxHeight: '35%', 
                                    }
                                    return <ul id='results' role='listbox' style={{...style,...menuStyle,marginLeft:'0',listStyleType:'none' } } children={items}/>
                                }}

                                renderItem={(item, isHighlighted) => (                                    
                                <li
                                    tabIndex='-1'
                                    id={isHighlighted?"selectedOption":""}
                                    role='option'
                                    data-item-value= {item.name || item.Title}
                                    item={JSON.stringify(item)}
                                    aria-selected={isHighlighted?"true":"false"}
                                    style={{
                                        background: isHighlighted ? "#f6f6f6" : "white",
                                        zIndex: "10",
                                       'borderLeft': '0.375rem solid ',
                                       'borderLeftColor': isHighlighted? '#cd040b' : 'transparent'
                                    }}
                                    className="searchDropdownItem"
                                    /* onClick={} 
                                    key={item.Id || ''}*/
                                >
                                    {item.logourl && <img src={item.type === "C" ? 
                                        domain + "/content/dam/verizon/personal/cluimages/" + item.logourl : 
                                        "https://hydracdnssl.verizon.net/ResourcesFiles/ImageLibrary/TMS/EPG/H/Sml/" +item.logourl}
                                        alt=""
                                    />}
                                    {item.name || item.Title}
                                </li>
                                )}
                                inputProps={{
                                    id:'search',
                                    "aria-owns":'results',
                                    "aria-activedescendant":'selectedOption',
                                    "aria-labelledby":'selectedOption',
                                    style: { marginBottom: 0,fontSize:'1rem'},
                                    className: "searchInput channel-list-auto-search",
                                    ref: 'channel-list-auto-search',
                                    placeholder: "Search shows and channels"
                                }}
                                value={this.state.searchValue}
                            />
                        {/* </FormGroup> */}
                    {this.state.showOtherPackagesMessage && <SearchInstruction>If you want more than 5 channels, upgrade to Fios TV Test Drive or remove one of your selections before adding another one.</SearchInstruction>}
                    {/* {this.state.channelList.length === 0 && !this.props.matchedChannelList && !this.state.hasLChannelsAndMNetworks && !this.state.hasPremiumChannels && !this.state.showOtherPackagesMessage && <SearchInstruction>Local TV channels are included.</SearchInstruction>} */} 
                    {!this.state.hasLChannelsAndMNetworks && !this.state.hasPremiumChannels && this.props.matchedChannelList && this.props.matchedChannelList.length === 0 && <SearchInstruction role="alert">This channel is currently not a part of Your Fios TV.</SearchInstruction>}
                    {this.state.hasLChannelsAndMNetworks && <SearchInstruction>{`Don’t forget, Your Fios TV includes local channels & major networks in your area.`}</SearchInstruction> }

                    {this.state.hasPremiumChannels && <SearchInstruction>{`You can select premium channels like `}
                    {this.state.premiumChannels.map((channel, index, arr) =>  (  
                             <React.Fragment key={index}>
                                {channel === "Showtime" ? channel.replace("Showtime","Paramount+ with Showitme, ") :index !== arr.length -1 ? channel + ', ' : channel}
                            </React.Fragment>
                        ))}
                        {` after you finish picking your five channels.`}
                        </SearchInstruction> }
                    {this.state.similarMatch !== '' && <SimilarMatchInfo>Do you mean <SimilarMatchText onClick={() => this.doSearch('search', this.state.similarMatch)}>{this.state.similarMatch}</SimilarMatchText></SimilarMatchInfo>}
                </ChannelListSearchContainer>
                }

                {this.isReskin ? 
                <ChannelListContainerRskn role="tablist">
                    {(this.state.selectedFilterTabId !== 'search') && this.state.channelList.map((channel, index) =>  (
                            <ChannelListItemRskn role="checkbox" aria-label={this.accesibilityChannelNameHandler(channel.name)} aria-checked={this.isSelectedChannel(channel.id)} key={channel.id} tabIndex={ this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 ?'-1':'0'} onKeyDown={(e) => this.handleKeyDown(e,channel)} onClick={ ()=> this.addToSelectedChannel(channel)}>
                                {this.isSelectedChannel(channel.id) && <SelectedChannelCheck ><AlternateCheckmark size="12" color="#398dfa"  /*lineColor="#ffffff" */ /></SelectedChannelCheck> }
                                {channel.logo && <img className={this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 && !this.isSelectedChannel(channel.id) ? 'disable-img' : ''} alt={channel.name} src={this.getImgPath(channel.logo)} style={{ height: '45px', width: '55px', border: '0px solid lightgray' }} />}
                            </ChannelListItemRskn>                                            
                        ))                            
                    }

                    {(this.state.selectedFilterTabId === 'search') && this.props.matchedChannelList && this.props.matchedChannelList.map((channel, index) =>  (
                            <ChannelListItemRskn role="checkbox" aria-label={this.accesibilityChannelNameHandler(channel.name)}  aria-selected={this.isSelectedChannel(channel.id)} key={channel.id} tabIndex={ this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 ?'-1':'0'} onKeyDown={(e) => this.handleKeyDown(e,channel)} onClick={ ()=> this.addToSelectedChannel(channel)}>
                                {this.isSelectedChannel(channel.id) && <SelectedChannelCheck ><AlternateCheckmark size="12" color="#398dfa"  /*lineColor="#ffffff" */ /></SelectedChannelCheck> }
                                {channel.logo && <img className={this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 && !this.isSelectedChannel(channel.id) ? 'disable-img' : ''} alt={channel.name} src={this.getImgPath(channel.logo)} style={{ height: '45px', width: '55px', border: '0px solid lightgray' }} />}
                            </ChannelListItemRskn>                                            
                        ))                                                                           
                    }
                </ChannelListContainerRskn> 
                :
                <ChannelListContainer role="tablist">
                    {(this.state.selectedFilterTabId !== 'search') && this.state.channelList.map((channel, index) =>  (
                            <ChannelListItem role="checkbox" aria-label={this.accesibilityChannelNameHandler(channel.name)} aria-checked={this.isSelectedChannel(channel.id)} key={channel.id} tabIndex={ this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 ?'-1':'0'} onKeyDown={(e) => this.handleKeyDown(e,channel)} onClick={ ()=> this.addToSelectedChannel(channel)}>
                                {this.isSelectedChannel(channel.id) && <SelectedChannelCheck ><AlternateCheckmark size="12" color="#398dfa"  /*lineColor="#ffffff" */ /></SelectedChannelCheck> }
                                {channel.logo && <img className={this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 && !this.isSelectedChannel(channel.id) ? 'disable-img' : ''} alt={channel.name} src={this.getImgPath(channel.logo)} style={{ height: '63px', width: '85px', border: '1px solid lightgray' }} />}
                            </ChannelListItem>                                            
                        ))                            
                    }

                    {(this.state.selectedFilterTabId === 'search') && this.props.matchedChannelList && this.props.matchedChannelList.map((channel, index) =>  (
                            <ChannelListItem role="checkbox" aria-label={this.accesibilityChannelNameHandler(channel.name)}  aria-selected={this.isSelectedChannel(channel.id)} key={channel.id} tabIndex={ this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 ?'-1':'0'} onKeyDown={(e) => this.handleKeyDown(e,channel)} onClick={ ()=> this.addToSelectedChannel(channel)}>
                                {this.isSelectedChannel(channel.id) && <SelectedChannelCheck ><AlternateCheckmark size="12" color="#398dfa"  /*lineColor="#ffffff" */ /></SelectedChannelCheck> }
                                {channel.logo && <img className={this.props.setSelectedChannels && this.props.setSelectedChannels.length === 5 && !this.isSelectedChannel(channel.id) ? 'disable-img' : ''} alt={channel.name} src={this.getImgPath(channel.logo)} style={{ height: '63px', width: '85px', border: '1px solid lightgray' }} />}
                            </ChannelListItem>                                            
                        ))                                                                           
                    }
                </ChannelListContainer>   
    }              
            </ChannelListFilterContentContainer>
            </React.Fragment>
            
        )
    }
}

export default ChannelListComponent;